import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useState, useCallback } from "react";

const Secondary = ({ buttonText, secondaryPosition }) => {
  const navigate = useNavigate();
  const secondaryStyle = useMemo(() => {
    return {
      position: secondaryPosition,
    };
  }, [secondaryPosition]);

  const onHomButtonClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  return (
    <button
      className="[border:none] py-4 px-8 bg-light relative rounded-31xl flex flex-row items-center justify-center"
      autoFocus
      // disabled
      style={secondaryStyle}
      onClick={onHomButtonClick}
    >
      <b className="relative text-base font-footnote text-dark text-left">
        {buttonText}
      </b>
    </button>
  );
};

export default Secondary;
